import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tracking-worksheet-page bg-grey-1" }
const _hoisted_2 = {
  key: 0,
  class: "tracking-worksheet-content q-pa-md"
}
const _hoisted_3 = { class: "row full-width items-center q-col-gutter-md" }
const _hoisted_4 = { class: "col-12 row items-start no-wrap" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "text-subtitle1 text-weight-bold text-grey-9" }
const _hoisted_7 = { class: "text-caption text-grey-7" }
const _hoisted_8 = {
  key: 0,
  class: "col-12 worksheet-completed-metrics"
}
const _hoisted_9 = { class: "row items-center q-col-gutter-md" }
const _hoisted_10 = { class: "col-auto" }
const _hoisted_11 = { class: "worksheet-metric-value" }
const _hoisted_12 = {
  key: 0,
  class: "col-auto"
}
const _hoisted_13 = { class: "worksheet-metric-value worksheet-metric-value--wrap" }
const _hoisted_14 = { class: "row items-center q-col-gutter-md q-mt-sm" }
const _hoisted_15 = {
  key: 0,
  class: "col-auto"
}
const _hoisted_16 = { class: "worksheet-metric-value" }
const _hoisted_17 = {
  key: 1,
  class: "col-auto"
}
const _hoisted_18 = { class: "worksheet-metric-value" }
const _hoisted_19 = { class: "row items-center q-col-gutter-md q-mt-sm" }
const _hoisted_20 = {
  key: 0,
  class: "col-auto"
}
const _hoisted_21 = { class: "worksheet-metric-value" }
const _hoisted_22 = {
  key: 1,
  class: "col-auto"
}
const _hoisted_23 = { class: "worksheet-metric-value" }
const _hoisted_24 = {
  key: 2,
  class: "col-auto"
}
const _hoisted_25 = { class: "worksheet-metric-value" }
const _hoisted_26 = {
  key: 1,
  class: "col-12 row items-center q-col-gutter-md worksheet-metrics"
}
const _hoisted_27 = {
  key: 0,
  class: "col-auto"
}
const _hoisted_28 = { class: "worksheet-metric-value" }
const _hoisted_29 = {
  key: 1,
  class: "col-auto"
}
const _hoisted_30 = { class: "worksheet-metric-value" }
const _hoisted_31 = {
  key: 2,
  class: "col-auto"
}
const _hoisted_32 = { class: "worksheet-metric-value" }
const _hoisted_33 = {
  key: 3,
  class: "col-auto"
}
const _hoisted_34 = { class: "worksheet-metric-value text-negative" }
const _hoisted_35 = { class: "col-12 row items-center no-wrap q-gutter-x-sm" }
const _hoisted_36 = ["onPointerenter"]
const _hoisted_37 = { class: "text-weight-medium" }
const _hoisted_38 = {
  key: 0,
  class: "text-caption text-grey-7 worksheet-description"
}
const _hoisted_39 = {
  key: 1,
  class: "column items-center justify-center q-pa-xl text-center tracking-worksheet-empty"
}
const _hoisted_40 = {
  key: 2,
  class: "column items-center justify-center q-pa-xl text-center tracking-worksheet-empty"
}
const _hoisted_41 = { class: "text-body1 q-mt-md text-grey-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_spinner_dots = _resolveComponent("q-spinner-dots")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_TracksheetMarkerPassagesPopover = _resolveComponent("TracksheetMarkerPassagesPopover")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_TracksheetRunPassages = _resolveComponent("TracksheetRunPassages")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_ctx.worksheetEntry && _ctx.worksheet)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          (_ctx.sourceLoadError)
            ? (_openBlock(), _createBlock(_component_q_banner, {
                key: 0,
                dense: "",
                class: "bg-red-1 text-red-10 q-mb-md"
              }, {
                action: _withCtx(() => [
                  _createVNode(_component_q_btn, {
                    flat: "",
                    dense: "",
                    round: "",
                    icon: "refresh",
                    "aria-label": "Retry verified passage source load",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadVerifiedPassageSources(true)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode("Retry source details", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.sourceLoadError) + " Passage status remains current; source and time details can be retried. ", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_table, {
            pagination: _ctx.pagination,
            "onUpdate:pagination": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pagination) = $event)),
            rows: _ctx.worksheet.rows,
            columns: _ctx.worksheetColumns,
            "visible-columns": _ctx.visibleWorksheetColumns,
            filter: _ctx.filter,
            "row-key": "pipelineSectionMarkerId",
            dense: "",
            flat: "",
            bordered: "",
            square: "",
            "rows-per-page-options": [25, 50, 0],
            class: "tracking-worksheet-table bg-white",
            "table-row-class-fn": _ctx.worksheetRowClass,
            onRowClick: _ctx.onWorksheetRowClick
          }, {
            top: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.worksheet.summary.runName), 1),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.worksheet.summary.verifiedMarkerCount) + " of " + _toDisplayString(_ctx.worksheet.summary.markerCount) + " markers verified ", 1)
                  ]),
                  _createVNode(_component_q_btn, {
                    flat: "",
                    dense: "",
                    "no-caps": "",
                    class: "q-ml-sm",
                    color: "primary",
                    icon: "file_download",
                    label: "Export CSV",
                    "aria-label": "Export tracksheet CSV",
                    onClick: _ctx.downloadCsv
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode("Export tracksheet CSV", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                (_ctx.isEndedRun)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _cache[13] || (_cache[13] = _createElementVNode("span", { class: "worksheet-metric-label" }, "Run", -1)),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.worksheet.summary.lifecycleState === 'X'
                      ? 'Cancelled'
                      : 'Completed'), 1)
                        ]),
                        (_ctx.worksheet.summary.pipelineName)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "worksheet-metric-label" }, "Pipeline", -1)),
                              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.worksheet.summary.pipelineName), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        (_ctx.worksheet.summary.launchTimeUtc)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "worksheet-metric-label" }, "Launch (UTC)", -1)),
                              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.formatUtc(_ctx.worksheet.summary.launchTimeUtc)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.worksheet.summary.receiveTimeUtc)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "worksheet-metric-label" }, "Receive (UTC)", -1)),
                              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.formatUtc(_ctx.worksheet.summary.receiveTimeUtc)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        (_ctx.worksheet.summary.deviceCount !== null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "worksheet-metric-label" }, "Devices", -1)),
                              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.worksheet.summary.deviceCount), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.worksheet.summary.passageCount !== null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "worksheet-metric-label" }, "Passages", -1)),
                              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.worksheet.summary.passageCount), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.worksheet.summary.verifiedPassageCount !== null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _cache[19] || (_cache[19] = _createElementVNode("span", { class: "worksheet-metric-label" }, "Verified passages", -1)),
                              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.worksheet.summary.verifiedPassageCount), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      (_ctx.worksheet.summary.nextMarkerName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _cache[20] || (_cache[20] = _createElementVNode("span", { class: "worksheet-metric-label" }, "Next", -1)),
                            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.worksheet.summary.nextMarkerName), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.worksheet.summary.currentSpeedMetersPerSecond !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _cache[21] || (_cache[21] = _createElementVNode("span", { class: "worksheet-metric-label" }, "Speed", -1)),
                            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.formatPrimarySpeed(
                      _ctx.worksheet.summary.currentSpeedMetersPerSecond
                    )) + " " + _toDisplayString(_ctx.primarySpeedUnitSymbol), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.worksheet.summary.nextMarkerEtaUtc)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _cache[22] || (_cache[22] = _createElementVNode("span", { class: "worksheet-metric-label" }, "Next ETA (UTC)", -1)),
                            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.formatUtc(_ctx.worksheet.summary.nextMarkerEtaUtc)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isOverdue(_ctx.worksheet.summary.nextMarkerOverdueSeconds))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _cache[23] || (_cache[23] = _createElementVNode("span", { class: "worksheet-metric-label" }, "Awaiting passage", -1)),
                            _createElementVNode("span", _hoisted_34, " overdue by " + _toDisplayString(_ctx.formatCountdown(_ctx.worksheet.summary.nextMarkerOverdueSeconds)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])),
                _createElementVNode("div", _hoisted_35, [
                  (_ctx.sourceLoadState === 'loading')
                    ? (_openBlock(), _createBlock(_component_q_spinner_dots, {
                        key: 0,
                        color: "primary",
                        size: "22px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, null, {
                            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                              _createTextVNode("Loading selected passage sources", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_q_select, {
                    modelValue: _ctx.visibleColumns,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visibleColumns) = $event)),
                    multiple: "",
                    borderless: "",
                    dense: "",
                    "options-dense": "",
                    "emit-value": "",
                    "map-options": "",
                    "display-value": _ctx.$q.lang.table.columns,
                    options: _ctx.worksheetColumns,
                    "option-value": "name",
                    style: {"min-width":"50px"},
                    onPopupHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeWorksheetColumnVariantMenu = null))
                  }, {
                    option: _withCtx((scope) => [
                      _createVNode(_component_q_item, _mergeProps(scope.itemProps, {
                        class: ["tracking-worksheet-column-option", _ctx.worksheetColumnDragClass(scope.opt.name)],
                        draggable: "true",
                        onDragstart: ($event: any) => (
                      _ctx.startWorksheetColumnDrag($event, scope.opt.name)
                    ),
                        onDragover: ($event: any) => (
                      _ctx.onWorksheetColumnDragOver(
                        $event,
                        scope.opt.name,
                        'vertical'
                      )
                    ),
                        onDrop: ($event: any) => (
                      _ctx.onWorksheetColumnDrop($event, scope.opt.name, 'vertical')
                    ),
                        onDragend: _ctx.endWorksheetColumnDrag
                      }), {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.opt.label), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          (_ctx.hasWorksheetColumnVariants(scope.opt.name))
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 0,
                                side: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_btn, {
                                    flat: "",
                                    dense: "",
                                    round: "",
                                    size: "sm",
                                    icon: "chevron_right",
                                    class: "tracking-worksheet-column-option__variant-button",
                                    "aria-label": `Choose column variant for ${scope.opt.label}`,
                                    onPointerdown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                                    onClick: _withModifiers(($event: any) => (
                          _ctx.openWorksheetColumnVariantMenu(scope.opt.name)
                        ), ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_tooltip, null, {
                                        default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                          _createTextVNode("Choose column variant", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _createVNode(_component_q_menu, {
                                        "model-value": 
                            _ctx.activeWorksheetColumnVariantMenu === scope.opt.name
                          ,
                                        anchor: "top end",
                                        self: "top start",
                                        offset: [4, 0],
                                        "no-parent-event": "",
                                        "onUpdate:modelValue": ($event: any) => (
                            _ctx.setWorksheetColumnVariantMenuOpen(
                              scope.opt.name,
                              $event
                            )
                          )
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_list, {
                                            dense: "",
                                            class: "tracking-worksheet-column-variant-menu"
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.worksheetColumnVariantOptions(
                                scope.opt.name
                              ), (variant) => {
                                                return (_openBlock(), _createBlock(_component_q_item, {
                                                  key: variant.value,
                                                  dense: "",
                                                  clickable: "",
                                                  onClick: _withModifiers(($event: any) => (
                                _ctx.setWorksheetColumnVariant(
                                  scope.opt.name,
                                  variant.value
                                )
                              ), ["stop"])
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_q_item_section, null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.worksheetColumnVariantLabel(
                                    scope.opt.name,
                                    variant.value
                                  )), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_q_item_section, { side: "" }, {
                                                      default: _withCtx(() => [
                                                        (
                                    _ctx.worksheetColumnVariant(scope.opt.name) ===
                                    variant.value
                                  )
                                                          ? (_openBlock(), _createBlock(_component_q_icon, {
                                                              key: 0,
                                                              name: "check",
                                                              color: "primary"
                                                            }))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["model-value", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1032, ["aria-label", "onClick"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1040, ["class", "onDragstart", "onDragover", "onDrop", "onDragend"])
                    ]),
                    "after-options": _withCtx(() => [
                      _createVNode(_component_q_separator),
                      _createVNode(_component_q_item, {
                        dense: "",
                        clickable: "",
                        class: "tracking-worksheet-column-order-reset",
                        disable: _ctx.isWorksheetColumnOrderDefault(),
                        onClick: _withModifiers(_ctx.resetWorksheetColumnOrder, ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, { name: "restart_alt" })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                              _createTextVNode("Reset column order", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disable", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "display-value", "options"]),
                  _createVNode(_component_q_input, {
                    modelValue: _ctx.filter,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filter) = $event)),
                    dense: "",
                    debounce: "300",
                    color: "primary",
                    "aria-label": "Filter tracksheet markers"
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_q_icon, { name: "search" })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ]),
            "header-cell": _withCtx((props) => [
              _createVNode(_component_q_th, {
                props: props,
                class: _normalizeClass(["tracking-worksheet-column-header", _ctx.worksheetColumnDragClass(props.col.name)]),
                draggable: "true",
                onDragstart: ($event: any) => (_ctx.startWorksheetColumnDrag($event, props.col.name)),
                onDragover: ($event: any) => (
              _ctx.onWorksheetColumnDragOver($event, props.col.name, 'horizontal')
            ),
                onDrop: ($event: any) => (_ctx.onWorksheetColumnDrop($event, props.col.name, 'horizontal')),
                onDragend: _ctx.endWorksheetColumnDrag
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.col.label), 1)
                ]),
                _: 2
              }, 1032, ["props", "class", "onDragstart", "onDragover", "onDrop", "onDragend"])
            ]),
            "body-cell-marker": _withCtx((props) => [
              _createVNode(_component_q_td, { props: props }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "row items-start no-wrap",
                    onPointerenter: ($event: any) => (_ctx.onMarkerPointerEnter($event, props.row)),
                    onPointerleave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onMarkerPointerLeave($event)))
                  }, [
                    (
                  props.row.latitude !== null && props.row.longitude !== null
                )
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          flat: "",
                          dense: "",
                          round: "",
                          size: "sm",
                          icon: "map",
                          class: "q-mr-xs q-mt-xs",
                          "aria-label": `Show ${props.row.markerName} on map`,
                          onClick: _withModifiers(($event: any) => (_ctx.showMarkerOnMap(props.row)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_tooltip, null, {
                              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                _createTextVNode("Show on map", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["aria-label", "onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_q_btn, {
                      flat: "",
                      dense: "",
                      round: "",
                      size: "sm",
                      icon: "format_list_bulleted",
                      class: "q-mr-xs q-mt-xs",
                      color: 
                  _ctx.popoverMarkerId === props.row.pipelineSectionMarkerId
                    ? 'blue-brand'
                    : undefined
                ,
                      "aria-label": `Show passages at ${props.row.markerName}`,
                      "data-testid": "tracksheet-marker-passages-icon",
                      onClick: _withModifiers(($event: any) => (_ctx.onMarkerPassagesIcon(props.row)), ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, null, {
                          default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                            _createTextVNode("Passages", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["color", "aria-label", "onClick"]),
                    (_ctx.popoverMarkerId === props.row.pipelineSectionMarkerId)
                      ? (_openBlock(), _createBlock(_component_TracksheetMarkerPassagesPopover, {
                          key: 1,
                          "pipeline-section-marker-id": props.row.pipelineSectionMarkerId,
                          "marker-name": props.row.markerName,
                          "pig-run-id": _ctx.pigRunId,
                          "run-passages": _ctx.runPassages,
                          loaded: _ctx.runPassagesLoaded,
                          "time-zone": _ctx.runPassagesTimeZone,
                          onClose: _ctx.closeMarkerPopover,
                          onPopoverUnmounted: _ctx.onMarkerPopoverUnmounted,
                          onShowAll: _ctx.onShowAllMarkerPassages,
                          onPopoverEnter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hoverIntent?.enterPopover())),
                          onPopoverLeave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hoverIntent?.leavePopover())),
                          onInteract: _cache[7] || (_cache[7] = ($event: any) => (_ctx.hoverIntent?.pin()))
                        }, null, 8, ["pipeline-section-marker-id", "marker-name", "pig-run-id", "run-passages", "loaded", "time-zone", "onClose", "onPopoverUnmounted", "onShowAll"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_37, _toDisplayString(props.row.markerName), 1),
                      (props.row.description)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(props.row.description), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 40, _hoisted_36)
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            "body-cell-status": _withCtx((props) => [
              _createVNode(_component_q_td, { props: props }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_badge, {
                    color: _ctx.rowStatusColor(props.row),
                    "text-color": "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.rowStatusLabel(props.row)), 1)
                    ]),
                    _: 2
                  }, 1032, ["color"])
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            _: 1
          }, 8, ["pagination", "rows", "columns", "visible-columns", "filter", "table-row-class-fn", "onRowClick"]),
          _createVNode(_component_TracksheetRunPassages, {
            ref: "runPassages",
            "pig-run-id": _ctx.pigRunId,
            "run-uids": _ctx.runPassageUids,
            "selected-marker-id": _ctx.selectedMarkerId,
            "selected-marker-name": _ctx.selectedMarkerName,
            "time-zone": _ctx.runPassagesTimeZone,
            onClearMarker: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedMarkerId = null)),
            onPassagesChanged: _ctx.onRunPassagesChanged
          }, null, 8, ["pig-run-id", "run-uids", "selected-marker-id", "selected-marker-name", "time-zone", "onPassagesChanged"])
        ]))
      : (_ctx.completedRunLoadState === 'loading')
        ? (_openBlock(), _createElementBlock("section", _hoisted_39, [
            _createVNode(_component_q_spinner_dots, {
              color: "primary",
              size: "40px"
            }),
            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "text-body1 q-mt-md text-grey-8" }, " Loading completed tracksheet... ", -1))
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_40, [
            _createVNode(_component_q_icon, {
              name: "route",
              color: "grey-5",
              size: "48px"
            }),
            _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.completedRunLoadError || 'No pig run selected.'), 1),
            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "text-caption q-mt-xs text-grey-6" }, " Select an active or completed run to view its tracksheet. ", -1))
          ]))
  ]))
}